<template>
  <section v-if="shipment_detail" class="detail-container-shipment px-1">
    <validation-observer ref="requestSubmit">
      <!-- Order Information -->
      <div class="title pt-1 pb-1">Customer Information</div>
      <b-card class="b-card-bg">
        <b-row class="px-2">
          <b-col lg="12">
            <b-row>
              <b-col cols="12" lg="4">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label class="custom-label-shipment">Service type</label>
                    <Select2
                      :disabled="true"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Select Service Type"
                      v-model="shipment_detail.service_type"
                      :options="service_types"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group>
                  <label class="custom-label-shipment">Order ID</label>
                  <b-form-input :disabled="true" v-model="bookingId" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="12">
            <b-row>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Company name"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label class="custom-label-shipment">Company name </label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="select2-v2"
                      rules="required"
                      :disabled="true"
                      placeholder="Enter your customer's name"
                      v-model="shipment_detail.company_id"
                      :options="{
                        isSearch: true,
                        value: 'code',
                        label: 'text',
                        data: company_list,
                        fields: [
                          {
                            field: 'name',
                            label: 'Company name',
                          },
                        ],
                      }"
                    />

                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Company address"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex"
                      >Company address
                    </label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="select2-v2"
                      placeholder="Enter your customer's address"
                      v-model="companyAddress"
                      :disabled="true"
                      :options="{
                        isSearch: true,
                        value: 'address',
                        label: 'address',
                        data: company_list,
                        fields: [
                          {
                            field: 'address',
                            label: 'Company address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Tax code"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex">Tax code</label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="select2-v2"
                      :disabled="true"
                      placeholder="Enter your customer's tax code"
                      v-model="companyTax"
                      :options="{
                        isSearch: true,
                        value: 'code',
                        label: 'tax_code',
                        data: company_list,
                        fields: [
                          {
                            field: 'code',
                            label: 'Tax Code',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="12">
            <b-row>
              <b-col cols="12" lg="2" class="pr-0">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label class="custom-label-shipment"
                      >To whom will booking be released?
                    </label>
                    <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    v-model="shipment_on_tms.customer_name"
                    placeholder="Customer Contact"
                  /> -->
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="true"
                      placeholder="Select Customer"
                      v-model="shipment_detail.customer_id"
                      :options="customer_list_options"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="2" class="pt-custom">
                <validation-provider
                  name="Phone"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="true"
                      v-model="shipment_detail.customer_phone"
                      placeholder="Phone"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Email"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label class="custom-label-shipment">Email </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="true"
                      v-model="shipment_detail.customer_email"
                      placeholder="Email"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-col>

          <b-col>
            <b-row>
              <b-col cols="12" lg="2" class="pr-0">
                <validation-provider
                  name="Contact WR1"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label class="custom-label-shipment">WR1's PIC </label>

                    <Select2
                      :disabled="true"
                      v-model="shipment_detail.sale_id"
                      :options="sales"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="2" class="pt-custom">
                <validation-provider
                  name="Phone"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="true"
                      v-model="shipment_detail.sale_phone"
                      placeholder="Phone"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Email"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label class="custom-label-shipment">Email </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="true"
                      v-model="shipment_detail.sale_email"
                      placeholder="Email"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <!-- END Order Information -->
      <div class="title pt-1 pb-1">Routing Details</div>
      <b-card class="b-card-bg">
        <b-row class="px-2">
          <b-col cols="12" lg="4">
            <validation-provider
              name="Quotation No."
              #default="{ errors }"
              rules=""
            >
              <b-form-group>
                <label class="custom-label-shipment">Quotation No.</label>
                <Select4
                  :disabled="true"
                  class="select2-v2"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Quotation No."
                  v-model="shipment_detail.quotation"
                  :options="{
                    isSearch: true,
                    value: 'id',
                    label: 'id',
                    data: quotations,
                    fields: [
                      {
                        field: 'id',
                        label: 'Quotation No.',
                      },
                      {
                        field: 'exp_date',
                        label: 'Valid to',
                      },
                      {
                        field: 'total_cost',
                        label: 'Total cost',
                      },
                    ],
                  }"
                />

                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="2"></b-col>
          <b-col lg="4"
            ><validation-provider
              name="Handling type"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label class="custom-label-shipment flex"
                  >Handling type
                  <div class="red">*</div></label
                >
                <Select4
                  :disabled="readonly"
                  class="select2-v2"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select Handling type"
                  v-model="shipment_detail.shippingType"
                  :options="{
                    value: 'id',
                    label: 'name',
                    data: transport_types,
                    fields: [
                      {
                        field: 'name',
                        label: 'Type',
                      },
                    ],
                  }"
                />

                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider></b-col
          >
        </b-row>
        <b-row class="px-2 mt-1">
          <b-col>
            <b-row>
              <b-col lg="10">
                <validation-provider
                  name="Pick up address"
                  #default="{ errors }"
                  rules="required"
                  v-if="!shipment_detail.isPickUpInput"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex"
                      >Pick up address
                      <span class="red">*</span>
                    </label>

                    <Select4
                      v-model="shipment_detail.pickup_location"
                      :key="locations.length + '_' +  'address_2' "

                      placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                      :disabled="readonly"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          {
                            field: 'abbreviations',
                            label: 'Abbreviations',
                          },
                          {
                            field: 'name',
                            label: 'Location',
                          },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="Pick up address"
                  #default="{ errors }"
                  rules="required"
                  v-if="shipment_detail.isPickUpInput"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex"
                      >Pick up address

                      <span class="red">*</span>
                    </label>

                    <b-form-input
                      :disabled="readonly"
                      class="iuput"
                      v-model="shipment_detail.valuePickupInput"
                      type="text"
                      placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="2" class="pt-custom"
                ><div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.isPickUpInput"
                  />

                  <div>
                    <div class="text-black">Other</div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col lg="10">
                <validation-provider
                  name="Delivery address"
                  #default="{ errors }"
                  rules="required"
                  v-if="!shipment_detail.isAddressInput"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex"
                      >Delivery address
                      <span class="red">*</span>
                    </label>

                    <Select4
                      v-model="shipment_detail.delivery_location"
                      :key="locations.length + '_' +  'Delivery_2' "
                      placeholder="Enter a previously used delivery address, or click OTHER to in put a new one"
                      :disabled="readonly"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          {
                            field: 'abbreviations',
                            label: 'Abbreviations',
                          },
                          {
                            field: 'name',
                            label: 'Location',
                          },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="Delivery address"
                  #default="{ errors }"
                  rules="required"
                  v-if="shipment_detail.isAddressInput"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex"
                      >Delivery address <span class="red">*</span></label
                    >

                    <b-form-input
                      :disabled="readonly"
                      class="iuput"
                      v-model="shipment_detail.valueAddressInput"
                      type="text"
                      placeholder="Enter a previously used delivery address, or click OTHER to in put a new one"
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="2" class="pt-custom">
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.isAddressInput"
                  />

                  <div>
                    <div class="text-black">Other</div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-2 mt-1">
          <b-col lg="4">
            <b-row class="px-1"
              ><label class="custom-label-shipment"
                >Pick up contact person</label
              ></b-row
            >
            <b-row>
              <b-col class="pr-0">
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="shipment_detail.pickUpContact.name"
                  type="text"
                  placeholder="Name"
                ></b-form-input>
              </b-col>
              <b-col>
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="shipment_detail.pickUpContact.phone"
                  type="text"
                  placeholder="phone"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="2"></b-col>
          <b-col lg="4">
            <b-row class="px-1">
              <label class="custom-label-shipment"
                >Delivery contact person</label
              >
            </b-row>
            <b-row>
              <b-col class="pr-0">
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="shipment_detail.deliveryContact.name"
                  type="text"
                  placeholder="Name"
                ></b-form-input>
              </b-col>
              <b-col>
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="shipment_detail.deliveryContact.phone"
                  type="text"
                  placeholder="Phone"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-2 mt-2">
          <b-col lg="4">
            <label class="custom-label-shipment">Pick up date</label>
            <b-row>
              <b-col class="pr-0">
                <date-picker
                  :disabled="readonly"
                  ref="datePicker"
                  v-model="shipment_detail.pickUpDate"
                  type="date"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  placeholder="Select date"
                  format="DD/MM/YY"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
              <b-col>
                <date-picker
                  :disabled="readonly"
                  v-model="shipment_detail.pickUpTime"
                  ref="datePicker"
                  type="time"
                  title-format="HH:mm"
                  time-title-format="HH:mm"
                  placeholder="Select time"
                  format="HH:mm"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="2"></b-col>
          <b-col lg="4">
            <label class="custom-label-shipment">Delivery date</label>
            <b-row>
              <b-col class="pr-0">
                <date-picker
                  :disabled="readonly"
                  ref="datePicker"
                  v-model="shipment_detail.deliveryDate"
                  type="date"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  placeholder="Select date"
                  format="DD/MM/YY"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
              <b-col>
                <date-picker
                  :disabled="readonly"
                  v-model="shipment_detail.deliveryTime"
                  ref="datePicker"
                  type="time"
                  title-format="HH:mm"
                  time-title-format="HH:mm"
                  placeholder="Select time"
                  format="HH:mm"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-2 mt-2">
          <b-col lg="4">
            <b-form-group>
              <label class="custom-label-shipment">Empty depot</label>

              <Select4
                v-model="shipment_detail.deport"
                placeholder="Empty depot"
                :disabled="readonly"
                :options="{
                  isSearch: true,
                  value: 'id',
                  label: 'text',
                  data: deports_locations,
                  fields: [
                    { field: 'abbreviations', label: 'Abbreviations' },
                    { field: 'name', label: 'Location' },
                    {
                      field: 'address',
                      label: 'Address',
                    },
                  ],
                }"
              />
            </b-form-group>
          </b-col>
          <b-col lg="2"></b-col>

          <b-col lg="4">
            <label class="custom-label-shipment">Payment terms</label>
            <Select2
              :disabled="readonly"
              placeholder="Payment Terms"
              v-model="shipment_detail.paymentTerms"
              :options="$Options.paymentTerms"
            />
          </b-col>
        </b-row>
      </b-card>
      <div class="title pt-1 pb-1">Cargo Details</div>
      <b-card class="b-card-bg">
        <b-row class="mb-2">
          <b-col lg="3">
            <label class="custom-label-shipment">Booking No.</label>
            <b-form-input
              :disabled="true"
              class="iuput"
              v-model="shipment_detail.cargo_booking"
              placeholder="Enter Booking No."
              required
            ></b-form-input>
          </b-col>
          <b-col lg="1"></b-col>
          <b-col lg="3">
            <label class="custom-label-shipment">Carrier</label>
            <Select4
              v-model="shipment_detail.shipping_line"
              placeholder="Carrier"
              :disabled="readonly"
              @reload="loadShippingType"
              :options="{
                isSearch: true,
                isReload: true,
                value: 'id',
                label: 'text',
                data: shipping_lines,
                fields: [
                  {
                    field: 'code',
                    label: 'Code',
                  },
                  {
                    field: 'name',
                    label: 'Shipping Line',
                  },
                ],
              }"
            />
          </b-col>
          <b-col lg="1"></b-col>
          <b-col lg="3">
            <label class="custom-label-shipment">Cargo closing time</label>
            <b-row>
              <b-col class="pr-0">
                <date-picker
                  :disabled="readonly"
                  ref="datePicker"
                  v-model="shipment_detail.cargo_closing_date"
                  type="date"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  placeholder="Select date"
                  format="DD/MM/YY"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
              <b-col>
                <date-picker
                  :disabled="readonly"
                  v-model="shipment_detail.cargo_closing_time"
                  ref="datePicker"
                  type="time"
                  title-format="HH:mm"
                  time-title-format="HH:mm"
                  placeholder="Select time"
                  format="HH:mm"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- filter -->
        <div>
          <b-row :style="showFilterContainer && 'height: 90px'">
            <b-col lg="2">
              <label
                class="custom-label-filter"
                @click="showFilterContainer = !showFilterContainer"
              >
                Filter
                <img
                  class="icon-filter"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII="
                  alt="logo"
                />
              </label>
            </b-col>

            <b-col lg="2">
              <label class="custom-label-filter-type mb-1">
                Commodity Type
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 24"
                  fill="#c2c2c2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-filter"
                >
                  <polygon
                    points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                  />
                </svg>
              </label>
              <Select2
                v-model="filterValueContainer.commodity_type"
                class="border-br"
                v-show="showFilterContainer"
                :options="goods_types"
              />
            </b-col>

            <!-- cont_types.filter((i) => i.group === 'Container truck') -->
            <b-col lg="2">
              <label class="custom-label-filter-type mb-1">
                Container type
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 24"
                  fill="#c2c2c2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-filter"
                >
                  <polygon
                    points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                  />
                </svg>
              </label>
              <Select2
                class="border-br"
                v-show="showFilterContainer"
                value="Container number"
                v-model="filterValueContainer.cont_type"
                :options="
                  cont_types.filter((i) => i.group === 'Container truck')
                "
              />
            </b-col>

            <b-col lg="2">
              <label class="custom-label-filter-type mb-1">
                Container number
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 24"
                  fill="#c2c2c2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-filter"
                >
                  <polygon
                    points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                  />
                </svg>
              </label>
              <Select2
                class="border-br"
                v-show="showFilterContainer"
                value="Container number"
                v-model="filterValueContainer.container_number"
                :options="containerNoList"
              />
            </b-col>
            <b-col lg="2">
              <label class="custom-label-filter-type mb-1">
                Truck ID
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 24"
                  fill="#c2c2c2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-filter"
                >
                  <polygon
                    points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                  />
                </svg>
              </label>
              <Select2
                class="border-br"
                v-model="filterValueContainer.truck_id"
                v-show="showFilterContainer"
                :options="truckList"
              />
            </b-col>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#28938d"
              stroke-width="2"
              stroke-linecap="round"
              @click="
                filterValueContainer = {
                  commodity_type: '',
                  cont_type: '',
                  container_number: '',
                  truck_id: '',
                }
              "
              v-show="showFilterContainer"
              style="margin-top: 41px"
              stroke-linejoin="round"
              class="feather feather-refresh-cw cursor-pointer"
            >
              <polyline points="23 4 23 10 17 10" />
              <polyline points="1 20 1 14 7 14" />
              <path
                d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
              />
            </svg>
          </b-row>
        </div>
        <div class="b-card-w b-rounded overflow-hidden">
          <b-row
            v-for="(
              itemCommodity, itemCommodityIndex
            ) in shipment_detail.valueContainer"
            :key="itemCommodity.id"
            class="mt-1 mb-3"
          >
            <b-col lg="12" class="z999">
              <b-row>
                <b-col lg="3">
                  <validation-provider
                    name="Commodity Type"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Commodity Type
                        <div class="red">*</div></label
                      >
                      <Select2
                        :disabled="readonly"
                        placeholder="Select Commodity type"
                        class="border-br"
                        v-model="itemCommodity.commodity_type"
                        :options="goods_types"
                      />
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col lg="1"></b-col>
                <b-col lg="3">
                  <validation-provider
                    name="Commodity"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Commodity
                        <div class="red">*</div>
                      </label>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        class="iuput border-br"
                        v-model="itemCommodity.commodity"
                        type="text"
                        placeholder="Commodity"
                        required
                      ></b-form-input>
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col class="mt-20" v-if="!readonly">
                  <div v-if="!itemCommodity.hasDelete" class="custom-add-line">
                    <b-img
                      @click="handleAddLineCommodity"
                      width="30px"
                      :src="iconAdd"
                      alt="logo"
                    />
                  </div>

                  <div v-if="itemCommodity.hasDelete" class="custom-delete">
                    <b-img
                      width="30px"
                      @click="handleDeleteCargoCommodity(itemCommodity.id)"
                      :src="remove"
                      alt="logo"
                    />
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="12" class="li-2" :key="reloadContainerLine">
              <b-row>
                <b-col lg="12" class="li-1">
                  <div class="b-card-w b-r" style="margin-top: 12px">
                    <b-row class="">
                      <b-col lg="3">
                        <validation-provider
                          name="Container Type"
                          #default="{ errors }"
                          rules="required"
                        >
                          <b-form-group>
                            <label class="flex"
                              >Container Type
                              <div class="red">*</div></label
                            >
                            <Select2
                              :class="errors.length > 0 ? 'is-invalid' : null"
                              :disabled="readonly"
                              class="border-br"
                              placeholder="Container Type"
                              v-model="itemCommodity.cont_type"
                              :options="
                                cont_types.filter(
                                  (i) => i.group === 'Container truck'
                                )
                              "
                            />
                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col lg="1"></b-col>
                      <b-col lg="3">
                        <validation-provider
                          name="Quantity"
                          #default="{ errors }"
                          rules="required|minNumber:0"
                        >
                          <b-form-group>
                            <label class="flex"
                              >Quantity
                              <div class="red">*</div>
                            </label>
                            <b-form-input
                              @input="
                                updateContainerLine3(
                                  itemCommodity,
                                  itemCommodityIndex
                                )
                              "
                              :state="errors.length > 0 ? false : null"
                              :disabled="readonly"
                              class="iuput border-br"
                              v-model="itemCommodity.quantity"
                              placeholder="Quantity"
                              type="number"
                              required
                            ></b-form-input>
                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col lg="1"></b-col>
                      <b-col lg="3">
                        <validation-provider
                          name="Total gross weight (Kgs)"
                          #default="{ errors }"
                          rules="required|minNumber:0"
                        >
                          <b-form-group>
                            <label class="flex"
                              >Total gross weight (Kgs)
                              <div class="red">*</div>
                            </label>
                            <cleave
                              :state="errors.length > 0 ? false : null"
                              :disabled="readonly"
                              :options="$Utils.CONSTANTS.cleaveNumeral"
                              v-model="itemCommodity.total_gross_weight"
                              class="form-control border-br"
                              placeholder="Total gross weight (Kgs)"
                              required
                            />

                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>

                <b-col lg="12" class="">
                  <b-row
                    v-for="(item, index) in itemCommodity.containerLine3"
                    :key="index"
                  >
                    <b-col lg="12">
                      <div
                        class="b-card-truckid b-r li-3"
                        style="margin-top: 20px"
                      >
                        <b-row class="align-items-center">
                          <b-col cols="12" lg="3">
                            <b-form-group>
                              <label class="custom-label-shipment"
                                >Container No.
                              </label>
                              <b-form-input
                                placeholder="Container No."
                                :disabled="readonly"
                                class="border-br"
                                v-model="item.container_no"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col cols="12" lg="3">
                            <b-form-group>
                              <label class="custom-label-shipment"
                                >Seal No.</label
                              >
                              <b-form-input
                                placeholder="Seal No."
                                :disabled="readonly"
                                class="border-br"
                                v-model="item.seal_no"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col cols="12" lg="3">
                            <b-form-group>
                              <label class="custom-label-shipment"
                                >Truck Id</label
                              >
                              <b-form-input
                                placeholder="TruckId."
                                disabled
                                v-model="item.truckId"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col lg="1" style="margin-top: 16px">
                            <div
                              class="collape"
                              @click="handleCollape(index, itemCommodityIndex)"
                            >
                              <p>
                                {{
                                  collape.includes(
                                    `${index}-${itemCommodityIndex}`
                                  )
                                    ? "Collape"
                                    : "Expand"
                                }}
                              </p>
                              <div class="icon-collape">
                                <b-icon
                                  :icon="
                                    collape.includes(
                                      `${index}-${itemCommodityIndex}`
                                    )
                                      ? 'chevron-up'
                                      : 'chevron-down'
                                  "
                                ></b-icon>
                              </div>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row
                          v-if="
                            collape.includes(`${index}-${itemCommodityIndex}`)
                          "
                          class="align-items-center p-1"
                        >
                          <div>
                            <b-form-group>
                              <label class="custom-label-shipment"
                                >Empty depot
                              </label>
                              <Select4
                                v-model="item.deport"
                                placeholder="Empty depot"
                                :disabled="true"
                                :options="{
                                  isSearch: true,
                                  value: 'id',
                                  label: 'text',
                                  data: deports_locations,
                                  fields: [
                                    {
                                      field: 'abbreviations',
                                      label: 'Abbreviations',
                                    },
                                    { field: 'name', label: 'Location' },
                                    {
                                      field: 'address',
                                      label: 'Address',
                                    },
                                  ],
                                }"
                              />
                            </b-form-group>
                          </div>

                          <b-col>
                            <b-form-group>
                              <label class="custom-label-shipment"
                                >Pick up address</label
                              >
                              <Select4
                                v-model="item.pickup_location"
                                :key="locations.length + '_' +  'address_1' "
                                
                                placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                                :disabled="true"
                                :options="{
                                  isSearch: true,
                                  value: 'id',
                                  label: 'text',
                                  data: locations,
                                  fields: [
                                    {
                                      field: 'abbreviations',
                                      label: 'Abbreviations',
                                    },
                                    {
                                      field: 'name',
                                      label: 'Location',
                                    },
                                    {
                                      field: 'address',
                                      label: 'Address',
                                    },
                                  ],
                                }"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <b-form-group>
                              <label class="custom-label-shipment"
                                >Pick up date</label
                              >
                              <b-form-input
                                :disabled="true"
                                class="iuput"
                                v-model="item.pickup_date"
                                type="text"
                                placeholder="Pick up date"
                                required
                              ></b-form-input>
                            </b-form-group>
                          </b-col>

                          <b-col>
                            <b-form-group>
                              <label class="custom-label-shipment"
                                >Delivery address </label
                              >
                              <Select4
                                v-model="item.delivery_location"
                                :key="locations.length + '_' +  'Delivery_1' "
                                :disabled="true"
                                :options="{
                                  isSearch: true,
                                  value: 'id',
                                  label: 'text',
                                  data: locations,
                                  fields: [
                                    {
                                      field: 'abbreviations',
                                      label: 'Abbreviations',
                                    },
                                    {
                                      field: 'name',
                                      label: 'Location',
                                    },
                                    {
                                      field: 'address',
                                      label: 'Address',
                                    },
                                  ],
                                }"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <b-form-group>
                              <label class="custom-label-shipment"
                                >Delivery date</label
                              >
                              <b-form-input
                                :disabled="true"
                                class="iuput"
                                v-model="item.delivery_date"
                                type="text"
                                placeholder="Delivery date"
                                required
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <div class="title custom-title">Additional Service</div>
      <b-card class="b-card-bg">
        <b-row>
          <div class="custom-additional">
            <input
              :key="reload"
              :disabled="true"
              type="checkbox"
              class="custom-checkbox-new"
              v-model="shipment_detail.has_customs"
              @change="() => this.reload++"
            />
            <div>Customs services</div>
          </div>
        </b-row>
        <div v-if="shipment_detail.has_customs" class="title custom-title mt-1">
          Customs Declaration
        </div>
        <b-row v-if="shipment_detail.has_customs">
          <b-col lg="3">
            <b-row>
              <b-col>
                <label class="custom-label-shipment">Customs type</label>
                <Select2
                  :disabled="true"
                  placeholder="Enter customs type"
                  v-model="shipment_detail.customs_type"
                  :options="customs_types"
                  v-if="!shipment_detail.has_other_custom"
                />
                <b-form-input
                  :disabled="true"
                  class="iuput"
                  v-model="shipment_detail.additional_custom_input"
                  type="text"
                  v-if="shipment_detail.has_other_custom"
                  placeholder="Enter customs type"
                  required
                ></b-form-input>
              </b-col>
              <b-col lg="0.5" class="pt-custom">
                <div class="custom-container-other">
                  <input
                    :disabled="true"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.has_other_custom"
                  />
                  <div>Other</div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="1"></b-col>
          <b-col lg="3">
            <label class="custom-label-shipment">
              Place of Custom declaration</label
            >

            <b-form-input
              :disabled="true"
              class="iuput"
              v-model="shipment_detail.place_of_custom"
              type="text"
              placeholder=" Place of Custom declaration"
              required
            ></b-form-input>
          </b-col>
          <b-col lg="1"></b-col>
          <b-col lg="3">
            <label class="custom-label-shipment">HS Code</label>

            <b-form-input
              :disabled="true"
              class="iuput"
              v-model="shipment_detail.HS_code_truck"
              type="text"
              placeholder="HS Code"
              required
            ></b-form-input>
          </b-col>
        </b-row>
      </b-card>
      <div class="title custom-title">Notes</div>
      <b-card class="b-card-notes">
        <b-form-textarea
          :disabled="true"
          class="textarea"
          v-model="shipment_detail.notes_truck"
          placeholder="Ex:
- Use 20'feet mooc only.
- Use short-nose tractor trucks.
- Please provide detailed addresses regarding multiple pick-up and delivery locations, if applicable"
          :rows="4"
          required
        ></b-form-textarea>
      </b-card>
      <div class="title custom-title flex">
        Billing Information
        <div class="red">*</div>
      </div>
      <b-card class="b-card-notes">
        <validation-observer name="billing" ref="validateBilling">
          <validation-provider
            name="Billing Information"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <b-form-input
                :disabled="true"
                class="iuput"
                v-model="shipment_detail.billingInformation"
                type="text"
                placeholder="Please provide billing Lift on -Lift of (Lo-Lo), other charges for third party, and direct billing from shipping lines."
                required
              ></b-form-input>

              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </validation-observer>
      </b-card>
    </validation-observer>
  </section>
</template>

<script>
import useJwt from "@/auth/jwt/useJwt";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select2 from "v-select2-component";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import mixins from "./mixin/mixin";
export default {
  mixins: [mixins],

  props: [
    "request_quotation",
    "shipment_on_tms",
    "shipment_on_fast",
    "shipment_details",
    "bookingId",
  ],
  // props: {
  //       request_quotation: { default: null },
  //       bookingId:{default:null}
  //   },
  components: {
    ValidationProvider,
    Select2,
    ValidationObserver,
  },
  data() {
    return {
      collape: [],
      reloadContainerLine: 1,
      checkFirst: false,
      iconAdd: require("@/assets/images/icons/add.png"),
      remove: require("@/assets/images/icons/remove.png"),
      check_country_pick_up: null,
      check_country_delivery: null,
      reload: 1,
      companyAddress: null,
      companyTax: null,
      userData: JSON.parse(localStorage.getItem("userData")),
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      maxFiles: false,
      isHideShowBookingEdit: false,
      isHideShowPkBookingEdit: false,
      cut_off: "",
      shipment_detail: {
        id: null,
        pick_up_date: null,
        delivery_date: null,
        agent: null,
        pickUpContact: {
          name: "",
        },
      },

      useLocations: [],
      moment,
      filterValueContainer: {
        commodity_type: null,
        commodity_number: null,
        truck_id: null,
        cont_type: null,
      },
      showFilterContainer: false,
      tempValueContainer: null,
    };
  },
  watch: {
    "shipment_detail.valueContainer": function (n, o) {
      if (o == null && !this.checkFirst) {
        this.shipment_detail.valueContainer.forEach((item, idx) => {
          item.orderDetailId = this.bookingId + this.pad(idx + 1);

          const numQuantity = parseInt(item.quantity);
          item.containerLine3 = Array.from(
            { length: numQuantity },
            (_, ix) => ({
              container_no: null,
              seal_no: null,
              truckId: item.orderDetailId + this.pad(ix + 1),
              deport: this.shipment_detail.deport,
              pickup_location: this.shipment_detail.pickup_location,
              delivery_location: this.shipment_detail.delivery_location,
              pickup_date: this.shipment_detail.pick_up_date,
              delivery_date: this.shipment_detail.delivery_date,
              collape: false,
            })
          );
        });
      }
    },

    filterValueContainer: {
      handler: function (val) {
        this.shipment_detail.valueContainer = this.tempValueContainer.filter(
          (item) => {
            if (
              val.commodity_type &&
              item.commodity_type != val.commodity_type
            ) {
              return false;
            }
            if (val.cont_type && item.cont_type != val.cont_type) {
              return false;
            }

            if (val.container_number) {
              let check = false;
              item.containerLine3.forEach((item2) => {
                if (item2.container_no == val.container_number) {
                  check = true;
                }
              });
              if (!check) {
                return false;
              }
            }

            if (val.truck_id) {
              let check = false;
              item.containerLine3.forEach((item2) => {
                if (item2.truckId == val.truck_id) {
                  check = true;
                }
              });
              if (!check) {
                return false;
              }
            }

            return true;
          }
        );
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("masterData", [
      "ports",
      "cont_types",
      "goods_types",
      "transport_types",
      "regions",
      "deports_locations",
      "service_types",
      "business_types",
      "customs_types",
      "incoterms",
      "sales",
      "companyItems",
      "regions",
      "company_list",
      "shipping_lines",
      "customer_list_options",
      "quotations",
      "locations",
    ]),

    truckList() {
      const data = [];
      this.tempValueContainer?.forEach((item, idx) => {
        item?.containerLine3.forEach((truckListItem) => {
          data.push({
            id: truckListItem.truckId,
            text: truckListItem.truckId,
          });
        });
      });
      return data;
    },
    containerNoList() {
      const data = [];
      this.tempValueContainer?.forEach((item, idx) => {
        item?.containerLine3.forEach((truckListItem) => {
          data.push({
            id: truckListItem.container_no,
            text: truckListItem.container_no,
          });
        });
      });
      return data;
    },

    company_list() {
      return this.companyItems;
    },
    readonly() {
      return (
        this.request_quotation.shipment_on_tms != null ||
        (this.request_quotation && this.request_quotation.accept_edit != 1) ||
        this.request_quotation.locked == 1 ||
        this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Client ||
        this.userData.userType ==
          this.$Utils.CONSTANTS.USER_TYPE_O.Client_Root ||
        this.request_quotation.status_id == 63
      );
    },
  },

  mounted() {
    this.$loading.show();

    if (this.request_quotation || this.shipment_details) {
      this.getUserLocation(this.request_quotation.customer_id);
      if (!this.isBlank(this.shipment_details)) {
        this.shipment_detail = this.shipment_details;
        if (!this.shipment_detail.has_customs) {
          this.shipment_detail.has_customs = this.request_quotation.has_customs;
        }
        if (!this.shipment_detail.customs_type) {
          this.shipment_detail.customs_type =
            this.request_quotation.customs_type;
        }
        if (!this.shipment_detail.custom_service_other) {
          this.shipment_detail.custom_service_other =
            this.request_quotation.custom_service_other;
        }
        if (!this.shipment_detail.customs_type_input) {
          this.shipment_detail.customs_type_input =
            this.request_quotation.customs_type_input;
        }
        if (!this.shipment_detail.HS_code_truck) {
          this.shipment_detail.HS_code_truck =
            this.request_quotation.HS_code_truck;
        }
        if (!this.shipment_detail.cargo_details_commodity_truck) {
          this.shipment_detail.cargo_details_commodity_truck =
            this.request_quotation.cargo_details_commodity_truck;
        }
        if (!this.shipment_detail.cargo_details_container_truck) {
          this.shipment_detail.cargo_details_container_truck =
            this.request_quotation.cargo_details_container_truck;
        }
        if (!this.shipment_detail.pickUpDate) {
          this.shipment_detail.pickUpDate = this.request_quotation.pickUpDate;
        }
        if (!this.shipment_detail.pickUpTime) {
          this.shipment_detail.pickUpTime = this.request_quotation.pickUpTime;
        }
        if (!this.shipment_detail.deliveryDate) {
          this.shipment_detail.deliveryDate =
            this.request_quotation.deliveryDate;
        }
        if (!this.shipment_detail.deliveryTime) {
          this.shipment_detail.deliveryTime =
            this.request_quotation.deliveryTime;
        }
        if (!this.shipment_detail.pickUpContact) {
          this.shipment_detail.pickUpContact =
            this.request_quotation.pickUpContact;
        }
        if (!this.shipment_detail.deliveryContact) {
          this.shipment_detail.deliveryContact =
            this.request_quotation.deliveryContact;
        }
        if (!this.shipment_detail.notes_truck) {
          this.shipment_detail.notes_truck = this.request_quotation.notes_truck;
        }
        this.shipment_detail.id = this.bookingId;

        if (!this.shipment_detail.valueContainer) {
          this.shipment_detail.valueContainer =
            this.request_quotation.valueContainer;
          this.checkFirst = false;
        } else {
          this.checkFirst = true;
        }

        // this.shipment_detail.deport_location =
        //   this.request_quotation.deport;
      } else {
        this.shipment_detail = this.request_quotation;
        this.shipment_detail.id = this.bookingId;

        this.shipment_detail.service_type = this.request_quotation.service_type;
        this.shipment_detail.has_customs =
          this.request_quotation?.has_customs || false;
        this.shipment_detail.shippingType =
          this.request_quotation?.shippingType || null;
        // this.shipment_detail.files = this.request_quotation.files;

        this.shipment_detail.deport = this.request_quotation.deport;

        this.shipment_detail.shippingType = this.request_quotation.shippingType;

        this.shipment_detail.cont_type = this.request_quotation.cont_type;

        this.shipment_detail.goods_type = this.request_quotation.goods_type;

        this.shipment_detail.trong_luong = this.request_quotation.trong_luong;

        this.shipment_detail.shipping_line =
          this.request_quotation.shipping_line;

        this.shipment_detail.HBL = this.request_quotation.HBL
          ? this.request_quotation.HBL
          : "";

        this.shipment_detail.container_no = this.request_quotation.container_no;

        this.shipment_detail.seal_no = this.request_quotation.seal_no;

        this.shipment_detail.business_type =
          this.request_quotation.business_type;

        this.shipment_detail.customs_addr = this.request_quotation.customs_addr;

        this.shipment_detail.hs_code = this.request_quotation.hs_code;

        this.shipment_detail.notes = this.request_quotation.notes;

        this.shipment_detail.billingInformation =
          this.request_quotation.billingInformation;
        this.shipment_detail.so_luong = this.request_quotation.so_luong;
        this.shipment_detail.customs_type = this.request_quotation.customs_type;

        this.shipment_detail.pickup_location =
          this.request_quotation.pickup_location;
        this.shipment_detail.delivery_location =
          this.request_quotation.delivery_location;
        if (this.shipment_on_fast) {
          this.shipment_detail.shipper = this.shipment_on_fast.shipper;
          this.shipment_detail.shipper_name =
            this.shipment_on_fast.shipper_name;
          this.shipment_detail.consignee = this.shipment_on_fast.consignee;
          this.shipment_detail.consignee_name =
            this.shipment_on_fast.consignee_name;
          this.shipment_detail.vessel = this.shipment_on_fast.vessel;
          this.shipment_detail.voyage = this.shipment_on_fast.voyage;
        }

        this.shipment_detail.customer_id = this.request_quotation.customer_id;
        this.shipment_detail.customer_name =
          this.request_quotation.customer_name;
        this.shipment_detail.customer_phone =
          this.request_quotation.customer_phone;
        this.shipment_detail.customer_email =
          this.request_quotation.customer_email;

        this.shipment_detail.sale_id = this.request_quotation.sale_id;
        this.shipment_detail.sale_name = this.request_quotation.sale_name;
        this.shipment_detail.sale_phone = this.request_quotation.sale_phone;

        this.shipment_detail.sale_email = this.request_quotation.sale_email;
        this.shipment_detail.customer_company_id =
          this.request_quotation.company_id;
        this.shipment_detail.pick_up_date = this.request_quotation.pick_up_date;
        this.shipment_detail.delivery_date =
          this.request_quotation.delivery_date;
        this.shipment_detail.cutOffDate = this.request_quotation.cutOffDate;

        this.shipment_detail.PICPickUp = this.request_quotation.PICPickUp;
        this.shipment_detail.PICDelivery = this.request_quotation.PICDelivery;

        console.log(this.request_quotation.valueContainer);
        // tao orderID
        this.shipment_detail.valueContainer.forEach((item, idx) => {
          item.orderDetailId = this.bookingId + this.pad(idx + 1);

          const numQuantity = parseInt(item.quantity);
          item.containerLine3 = Array.from(
            { length: numQuantity },
            (_, ix) => ({
              container_no: null,
              seal_no: null,
              truckId: item.orderDetailId + this.pad(ix + 1),
              deport: this.shipment_detail.deport,
              pickup_location: this.shipment_detail.pickup_location,
              delivery_location: this.shipment_detail.delivery_location,
              pickup_date: this.shipment_detail.pick_up_date,
              delivery_date: this.shipment_detail.delivery_date,
              collape: true,
            })
          );
        });
      }
    }
    // this.shipment_detail = { ...this.request_quotation };
    this.isHideShow =
      this.shipment_detail?.other_pickup_location != null ? true : false;

    this.isHideShowPk =
      this.shipment_detail?.other_delivery_location != null ? true : false;

    this.isHideShow =
      this.shipment_detail?.other_pickup_region != null ? true : false;

    this.isHideShowPk =
      this.shipment_detail?.other_delivery_region != null ? true : false;

    this.cut_off = this.shipment_detail.cut_off;

    this.$store.commit("masterData/SET_SHIPPING_DETAIL", this.shipment_detail);
    if (
      this.shipment_detail &&
      this.company_list &&
      this.company_list.length > 0
    ) {
      const customerCompany = this.company_list.find(
        (item) => item.id === this.shipment_detail.company_id
      );

      if (customerCompany) {
        this.companyAddress = customerCompany.address;
        this.companyTax = customerCompany.tax_code;
        this.reload++;
      } else {
        // Xử lý khi không tìm thấy đối tượng khớp với customer_company_id
        this.companyAddress = "";
        this.companyTax = "";
      }
    } else {
      // Xử lý khi shipment_detail hoặc company_list rỗng
      this.companyAddress = "";
      this.companyTax = "";
    }

    this.tempValueContainer = JSON.parse(
      JSON.stringify(this.shipment_detail.valueContainer)
    );
  },

  methods: {
  
    handleCollape(i, x) {
      var index = `${i}-${x}`;
      if (this.collape.includes(index)) {
        this.collape = this.collape.filter((item) => item !== index);
      } else {
        this.collape.push(index);
      }
    },

    pad(d) {
      return d < 10 ? "0" + d.toString() : d.toString();
    },
    updateContainerLine3(itemCommodity, itemContainerIndex) {
      if (itemCommodity.quantity < 0) {
        itemCommodity.quantity = 0;
      } else if (itemCommodity.quantity > 99) {
        itemCommodity.quantity = 99;
      }
      const quantity = parseInt(itemCommodity.quantity);

      itemCommodity.orderDetailId =
        this.bookingId + this.pad(itemContainerIndex + 1);
      itemCommodity.containerLine3 = Array.from(
        { length: quantity },
        (_, idx) => ({
          container_no: null,
          seal_no: null,
          truckId: itemCommodity.orderDetailId + this.pad(idx + 1),
          deport: null,
          pickup_location: null,
          delivery_location: null,
          pickup_date: null,
          delivery_date: null,
          collape: true,
        })
      );

      this.reloadContainerLine++;
    },
    disabledRangeDelivery: function (date) {
      if (this.shipment_detail.pick_up_date) {
        var mydate = moment(this.shipment_detail.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },

    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    hideShows: function () {
      this.isHideShow = !this.isHideShow;
    },
    hideShowsPk: function () {
      this.isHideShowPk = !this.isHideShowPk;
    },
    changeHideShows: function () {
      this.isHideShowBookingEdit = !this.isHideShowBookingEdit;
    },
    changeHideShowsPk: function () {
      this.isHideShowPkBookingEdit = !this.isHideShowPkBookingEdit;
    },
    handleAddLineCommodity() {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const randomID2 =
        Math.random().toString(30).substr(1, 8) + "-" + Date.now();
      const randomID3 =
        Math.random().toString(30).substr(1, 7) + "-" + Date.now();
      const newElement = {
        id: randomID,
        hasDelete: true,
        commodity_type: null,
        commodity: null,
        orderDetailId:
          this.bookingId +
          this.pad(this.shipment_detail.valueContainer.length + 1),
        containerLine3: [
          {
            id: randomID3,
            container_no: null,
            seal_no: null,
            truckId:
              this.bookingId +
              this.pad(this.shipment_detail.valueContainer.length + 1) +
              this.pad(1),
            deport: null,
            pickup_location: null,
            delivery_location: null,
            pickup_date: null,
            delivery_date: null,
            collape: true,
          },
        ],
        container_type: null,
        quantity: 1,
        total_gross_weight: null,
      };
      this.shipment_detail.valueContainer.push(newElement);
    },
    handleDeleteCargoCommodity(id) {
      this.shipment_detail.valueContainer =
        this.shipment_detail.valueContainer.filter((item) => item.id !== id);
    },
    handleAddLineContainer(id) {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const randomID3 =
        Math.random().toString(36).substr(2, 8) + "-" + Date.now();
      const index = this.shipment_detail.valueContainer.findIndex(
        (item) => item.id === id
      );
    },
  },
};
</script>

<style lang="scss">
.custom-container-other {
  display: flex;
  align-items: center;
  gap: 5px;
  div {
    font-weight: 600;
    color: #000000;
  }
}
.detail-container-shipment {
  .select2-selection--single:before {
    top: 13px;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=") !important;
  }
  .flex {
    display: flex;
  }
  .custom-label-shipment {
    font-size: 1rem;
    color: #000000;
    font-weight: 600;
  }
  .b-card-bg-notes {
    border-radius: 1rem;
    background-color: white;
    height: auto;
    padding: 1.5rem;
    @media (max-width: 992px) {
      height: 350px;
    }
  }
  .pt-custom {
    padding-top: 1.75rem;
  }
  .custom-additional {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-left: 15px;
    div {
      color: #000000;
      font-size: medium;
      font-weight: 600;
    }
  }
  .mt-25 {
    margin-top: 28px !important;
  }
  & .form-control {
    border: none;
  }
  & .select2-container--default .select2-selection--single {
    border: none;
  }
  & .mx-input {
    border: none;
  }

  .select2 {
    height: 28px !important;
  }
  .mt-20 {
    margin-top: 2rem;
  }
  .custom-delete {
    cursor: pointer;
  }
  .custom-add-line {
    cursor: pointer;
  }
  label {
    font-size: 1rem;
    color: #000000;
    font-weight: 600;
  }
}
</style>
